import React, { createContext, useContext, useState } from "react";

const FormValuesContext = createContext({});

const FormValuesProvider = ({ children }) => {
  const [values, setValues] = useState();
  return (
    <FormValuesContext.Provider value={{ values, setValues }}>
      {children}
    </FormValuesContext.Provider>
  );
};

export const useFormValuesContext = () => useContext(FormValuesContext);

export default FormValuesProvider;
